/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import SVG from 'react-inlinesvg'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../template/_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-lg-row flex-column-fluid h-100 bg-auth'
    >
      {/* begin::Aside */}
      <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-1'>
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          <h1 className='text-white fs-3qx fw-bolder text-center mb-2'>Bienvenido a</h1>
          <Link to='/'>
            <SVG src={toAbsoluteUrl('/media/soyfri-media/logo-planilla-transparent.svg')} />
          </Link>
        </div>
      </div>
      {/* end::Aside */}
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 px-10 py-md-10 order-2 order-lg-2'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px w-xl-600px bg-body rounded shadow-sm px-10 px-lg-29 mx-auto'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {AuthLayout}
